__turbopack_context__.v({
  "buttonsWrapper": "Y60YsG_buttonsWrapper",
  "detailRow": "Y60YsG_detailRow",
  "label": "Y60YsG_label",
  "modalContent": "Y60YsG_modalContent",
  "reservationDetails": "Y60YsG_reservationDetails",
  "value": "Y60YsG_value",
});
